import gql from "graphql-tag";

const COMMENTS_BY_BLOG = gql`
    query Comments($blog: ID!){
        comments(limit: 10, where: { blog: { id: $blog} }){
            id,
            name,
            comment,
            createdAt
            blog{
                id
            }
            replies{
                name
                reply
                createdAt
            }
        }
    }
`
export default COMMENTS_BY_BLOG